export var ResponseType;

(function (ResponseType) {
  ResponseType["CODE"] = "code";
  ResponseType["TOKEN"] = "token";
  ResponseType["ID_TOKEN"] = "id_token";
  ResponseType["ID_TOKEN_TOKEN"] = "id_token token";
})(ResponseType || (ResponseType = {}));

export var GrantType;

(function (GrantType) {
  GrantType["AUTHORIZATION_CODE"] = "authorization_code";
  GrantType["PASSWORD"] = "password";
  GrantType["CLIENT_CREDENTIALS"] = "client_credentials";
  GrantType["REFRESH_TOKEN"] = "refresh_token";
})(GrantType || (GrantType = {}));

export var TokenName;

(function (TokenName) {
  TokenName["ACCESS_TOKEN"] = "access_token";
  TokenName["CLIENT_TOKEN"] = "client_token";
  TokenName["ID_TOKEN"] = "id_token";
})(TokenName || (TokenName = {}));

export var PasswordType;

(function (PasswordType) {
  PasswordType["ORIGINAL_PASSWORD"] = "original_password";
  PasswordType["RESET_PASSWORD"] = "reset_password";
})(PasswordType || (PasswordType = {}));

export var ErrorCode;

(function (ErrorCode) {
  ErrorCode["INVALID_REQUEST"] = "invalid_request";
  ErrorCode["SERVER_ERROR"] = "server_error";
  ErrorCode["ACCESS_DENIED"] = "access_denied";
  ErrorCode["INVALID_TOKEN"] = "invalid_token";
  ErrorCode["INSUFFICIENT_SCOPE"] = "insufficient_scope";
  ErrorCode["DISAPPROVED"] = "disapproved";
  ErrorCode["CONSENT_REQUIRED"] = "consent_required";
  ErrorCode["INVALID_CLIENT"] = "invalid_client";
  ErrorCode["INVALID_GRANT"] = "invalid_grant";
  ErrorCode["INVALID_SCOPE"] = "invalid_scope";
  ErrorCode["UNAUTHORIZED_CLIENT"] = "unauthorized_client";
  ErrorCode["UNSUPPORTED_GRANT_TYPE"] = "unsupported_grant_type";
  ErrorCode["UNSUPPORTED_RESPONSE_TYPE"] = "unsupported_response_type";
  ErrorCode["UNSUPPORTED_TOKEN_TYPE"] = "unsupported_token_type";
  ErrorCode["USER_NOT_FOUND"] = "user_not_found";
  ErrorCode["USER_CONFLICT"] = "user_conflict";
  ErrorCode["USER_VERIFY_ERROR"] = "user_verify_error";
  ErrorCode["APP_NOT_FOUND"] = "app_not_found";
  ErrorCode["APP_CONFLICT"] = "app_conflict";
  ErrorCode["CONSENT_NOT_FOUND"] = "consent_not_found";
  ErrorCode["CONSENT_CONFLICT"] = "consent_conflict";
  ErrorCode["SCOPE_GROUP_NOT_FOUND"] = "scope_group_not_found";
  ErrorCode["SCOPE_GROUP_CONFLICT"] = "scope_group_conflict";
  ErrorCode["INVALID_EMAIL_CODE"] = "invalid_email_code";
})(ErrorCode || (ErrorCode = {}));